import { FlaskConical } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const PlanningBanner = ({ label = "MOCK / PLANNING-ONLY", description = "This workflow is not represented by an approved production table and remains isolated in the mock adapter." }: { label?: string; description?: string }) => (
  <div className="flex flex-col gap-2 rounded-xl border border-warning/25 bg-warning/10 p-4 text-sm sm:flex-row sm:items-center" data-testid="planning-only-banner">
    <Badge variant="outline" className="w-fit border-warning/30 text-warning" data-testid="mock-watermark"><FlaskConical className="mr-1 size-3" />{label}</Badge>
    <p className="text-muted-foreground" data-testid="planning-only-description">{description}</p>
  </div>
);
